import {
  doc,
  getDoc,
  where,
  increment,
  onSnapshot,
  setDoc,
  updateDoc,
  collection,
  orderBy,
  query,
  limit,
  getDocs,
} from "firebase/firestore";
import { ref, uploadBytes } from "firebase/storage";
import React from "react";
import { forArrayLength, getId } from "../misc/helperfuncs";
import db, { storage } from "./fireInit";

const collectionObj = {
  open: {
    statements: [],
  },
  saved: {
    focuses: [],
  },
  history: {
    focuses: [],
    statements: [],
    changes: [],
    thoughts: [],
    reports: [],
  },
  general: {
    changes: [],
    focuses: [],
  },
  active: {
    goal: null,
    focus: null,
    box: null,
    mood: null,
  },
};

function getArrayListener(player, boxTypeNames, onSnap, takeUnsubs) {
  const collections = ["open", "saved"];
  const unsubs = [];
  forArrayLength(collections, (collection) => {
    const documents = Object.keys(collectionObj[collection]).concat(
      boxTypeNames
    );

    forArrayLength(documents, (document) => {
      const docRef = doc(db, `players/${player.uid}/${collection}/`, document);
      const unsub = onSnapshot(docRef, (snap) => {
        onSnap(collection, document, snap.data().array);
      });
      unsubs.push(unsub);
    });
  });
  takeUnsubs(unsubs);
  return () => {
    forArrayLength(unsubs, (unsub) => {
      unsub();
    });
  };
}

function makeMoodHistories(uid) {
  // moodCollections
  const moods = [
    "happy",
    "exhausted",
    "angry",
    "confused",
    "productive",
    "sad",
  ];

  const docRef = doc(db, `players/${uid}/goalHistory/`, "overview");
  setDoc(docRef, { completed: 0 });

  forArrayLength(moods, (document) => {
    const docRef = doc(db, `players/${uid}/moodsHistory/`, document);
    setDoc(docRef, { array: [] });
  });
}

function makeBoxHistories(boxes, uid, setBoxes) {
  forArrayLength(
    boxes.map((b) => !b.setup),
    (boxes) => {
      const docRef = doc(db, `players/${uid}/${boxes.name}/`, "overview");
      setDoc(docRef, { completed: 0 });
    }
  );
}

function makePlayerDocuments(uid) {
  const collections = ["open", "saved", "history"];
  forArrayLength(collections, (collection) => {
    const documents = Object.keys(collectionObj[collection]);
    forArrayLength(documents, (document) => {
      const docRef = doc(db, `players/${uid}/${collection}/`, document);
      setDoc(docRef, { array: [] });
    });
  });
  makeMoodHistories(uid);
}

const emptyAdded = {
  categories: {
    events: 0,
    focuses: 0,
    goals: 0,
    tasks: 0,
    leasures: 0,
    vices: 0,
    problems: 0,
    changes: 0,
    routines: 0,
  },
  things: {
    events: 0,
    routines: 0,
    focuses: 0,
    goals: 0,
    tasks: 0,
    leasures: 0,
    vices: 0,
    problems: 0,
    changes: 0,
  },
};

function createPlayer(onCreated) {
  console.log("FIREFUNC createPlayer");
  const uid = getId();

  const player = {
    subscriber: false,
    boxTypes: {},
    profileImage: null,
    changes: [],
    checkmarks: 0,
    active: {
      box: null,
      focus: null,
      goal: null,
      mood: null,
    },
    name: "New Player",
    online: true,
    password: null,
    playingWith: [],
    points: {
      open: 0,
      earned: 0,
      donated: 0,
      given: 0,
    },
    trophies: { open: 0, earned: 0, given: 0, donated: 0 },
    uid,
    verifiedId: null,
    joined: Date.now(),
    privateInformation: {
      firstName: null,
      lastName: null,
      city: null,
      country: null,
      zip: null,
    },
    minutesPlayed: 0,
    playing: true,
    voted: {
      images: [],
    },
    firstTime: true,
    added: {
      ...emptyAdded,
      lastReset: null,
    },
  };
  const playerRef = doc(db, "players", uid);
  localStorage.setItem("uid", JSON.stringify(uid));

  setDoc(playerRef, player).then(() => {
    makePlayerDocuments(uid);
    onCreated(uid);
  });
}

function uploadImageToStorage(path, image, thenFunc) {
  console.log("FIREFUNC uploadImageToStorage ");
  const imageStorageRef = ref(storage, path + "/" + image.name);
  uploadBytes(imageStorageRef, image).then((snapshot) => {
    if (thenFunc != null) thenFunc(snapshot.metadata.fullPath);
  });
}

async function getGeneralLists(onReceived) {
  console.log("FIREFUNC getGeneralLists");
  const listsRef = doc(db, "general", "lists");
  const doc = await getDoc(listsRef);
  onReceived(doc.data());
}

async function updatePlayerAttribute(uid, field, value) {
  console.log("FIREFUNC updatePlayerAttribtue", uid, field, value);
  const playerRef = doc(db, "players/", uid);
  updateDoc(playerRef, { [field]: value });
}

function handlePlayerRetrival(
  setPlayer,
  setVerifiedId,
  onRetrieved,
  onArrayFound,
  setAllActive
) {
  console.log("FIREFUNC handlePlayerRetrival");
  const uid = JSON.parse(localStorage.getItem("uid"));
  const verifiedId = JSON.parse(localStorage.getItem("verifiedId"));
  if (verifiedId) setVerifiedId(verifiedId);
  // create Userlistener
  async function createPlayerListener(uid) {
    const playerRef = doc(db, "players", uid);
    const player = await getDoc(playerRef);

    if (player.data()) {
      setAllActive(
        player.data().active.goal,
        player.data().active.focus,
        player.data().active.box,
        player.data().active.mood
      );
      onSnapshot(playerRef, (snap) => {
        setPlayer(snap.data());
      });
    } else {
      localStorage.removeItem("uid");
      createPlayer(createPlayerListener);
    }
  }

  if (uid) createPlayerListener(uid);
  else createPlayer(createPlayerListener);
}

function incrementPlayerField(uid, field, value) {
  console.log("FIREFUNC incrementPlayerField");
  const playerRef = doc(db, "players/", uid);
  updateDoc(playerRef, { [field]: increment(value) });
}

async function getTypeObject(pluralType, listObject, onRetrieved) {
  console.log("FIREFUNC getTypeObject");
  const docRef = doc(db, "boxes/", pluralType);
  const objectDoc = await getDoc(docRef);
  onRetrieved(objectDoc.data()[listObject] ?? {});
}

async function updateTypeObject(pluralType, field, newObject, onUpdated) {
  const docRef = doc(db, "boxes/", pluralType);
  updateDoc(docRef, { [field]: newObject }).then(() => {
    onUpdated();
  });
}

async function getObjectFromFirestore(
  type,
  id,
  addGeneralObjects,
  getPluralType,
  onObjectRetrieved
) {
  console.log("FIREFUNC getObjectFromFirestore");
  const docRef = doc(db, `boxes/${getPluralType(type)}/collection`, id);
  const d = await getDoc(docRef);
  addGeneralObjects([d.data()], getPluralType);
  onObjectRetrieved(d.data());
}

function resetAddedQuota(player) {
  const timeElapsed = Date.now() - player.added.lastReset ?? 0;
  if (timeElapsed > 86400000) {
    const newEmptyAdded = { ...emptyAdded, lastReset: Date.now() };

    const playerRef = doc(db, "players/", player.uid);
    updateDoc(playerRef, { added: newEmptyAdded });
  }
}

function updatePlayerArray(uid, collection, document, newArray) {
  const docRef = doc(db, `players/${uid}/${collection}/`, document);
  updateDoc(docRef, { array: newArray });
}

async function incrementGeneralArray(
  getPluralType,
  object,
  dataDoc,
  arrayName,
  addedValue,
  onIncremented
) {
  const docRef = doc(
    db,
    `boxes/${getPluralType(object.type)}/collection/${object.id}/data`,
    dataDoc
  );
  const dDoc = await getDoc(docRef);
  const docArray = dDoc.data()[arrayName];
  docArray.changed = true;
  docArray.push(addedValue);

  updateDoc(docRef, { [arrayName]: docArray }).then(() => {
    const objectRef = doc(
      db,
      `boxes/${getPluralType(object.type)}/collection`,
      object.id
    );
    updateDoc(objectRef, { [dataDoc]: increment(1) }).then(() => {
      onIncremented(object);
    });
  });
}

async function reduceGeneralArray(
  getPluralType,
  type,
  objectId,
  dataDoc,
  arrayName,
  removedValue,
  identifier,
  onIncremented
) {
  const docRef = doc(
    db,
    `boxes/${getPluralType(type)}/collection/${objectId}/data`,
    dataDoc
  );
  const dDoc = await getDoc(docRef);
  var docArray = dDoc.data()[arrayName];

  if (identifier)
    docArray = docArray.filter(
      (o) => o[identifier] != removedValue[identifier]
    );

  updateDoc(docRef, { [arrayName]: docArray }).then(() => {
    const objectRef = doc(
      db,
      `boxes/${getPluralType(type)}/collection`,
      objectId
    );
    updateDoc(objectRef, { [dataDoc]: increment(-1) }).then(() => {
      onIncremented();
    });
  });
}

async function addToDataRelatedArray(
  getPluralType,
  type,
  objectId,
  dataDoc,
  itemId,
  playerId
) {
  const dataRef = doc(
    db,
    `boxes/${getPluralType(type)}/collection/${objectId}/data`,
    getPluralType(dataDoc)
  );
  const dDoc = await getDoc(dataRef);
  const relatedObject = dDoc.data().related;
  if (relatedObject[itemId]) relatedObject[itemId].push(playerId);
  else relatedObject[itemId] = [playerId];
  updateDoc(dataRef, { related: relatedObject });
}

async function addRatingToGeneralObject(
  getPluralType,
  type,
  objectId,
  ratingField,
  rating,
  playerId
) {
  const docRef = doc(
    db,
    `boxes/${getPluralType(type)}/collection/${objectId}/data`,
    ratingField
  );
  const ratingDoc = await getDoc(docRef);
  const ratingObj = ratingDoc.data();
  ratingObj[rating].push(playerId);

  updateDoc(docRef, { ratings: ratingObj });
}

async function findObjectsByEntries(queries, type) {
  const queriesArray = [];
  queries.forEach((q) => {
    queriesArray.push(where(q[0], "array-contains-any", q[1]));
  });
}

async function saveBoxType(boxType, onUploaded) {
  const docRef = doc(db, "boxTypes/", boxType.names.plural);
  const boxDoc = await getDoc(docRef);

  function createCollectionDocument() {
    const boxRef = doc(db, "boxes/", boxType.names.plural);
    setDoc(boxRef, { categories: {}, things: {} });
  }

  const boxObj = boxDoc.data();
  if (!boxObj) {
    setDoc(docRef, boxType);
    const infoRef = doc(db, "boxTypes", "information");
    const infoSnap = await getDoc(infoRef);
    const infoTypeNamens = infoSnap.data().typeNames;
    if (infoTypeNamens[boxType.names.plural])
      infoTypeNamens[boxType.names.plural] += 1;
    else infoTypeNamens[boxType.names.plural] = 1;

    createCollectionDocument();
    updateDoc(infoRef, { typeNames: infoTypeNamens });
  }
  onUploaded(boxObj != null);
}

async function getBoxTypeDocuments(onReceived) {
  const colRef = collection(db, "boxTypes");
  const q = query(colRef, orderBy("used", "desc"), limit(30));
  const querySnapshot = await getDocs(q);
  const docs = [];
  querySnapshot.forEach((doc) => {
    docs.push(doc.data());
  });
  onReceived(docs);
}

function incrementBoxTypeUsed(boxTypeName, value) {
  const docRef = doc(db, "boxTypes/", boxTypeName);
  updateDoc(docRef, { used: increment(value) });
}

async function getBoxTypesInformation(onReceived) {
  const docRef = doc(db, "boxTypes/", "information");
  const docSnap = await getDoc(docRef);
  onReceived(docSnap.data());
}

async function checkGeneralRelatedTypes(related, boxTypeName) {
  const fireBoxTypeRef = doc(db, "boxTypes/", boxTypeName);
  const fireBoxTypeSnap = await getDoc(fireBoxTypeRef);
  const relatedTypes = fireBoxTypeSnap.data().related.types;
  const relatedDescriptions = fireBoxTypeSnap.data().related.descriptions;
  forArrayLength(related.types, (localType) => {
    if (!relatedTypes.includes(localType)) {
      relatedTypes.push(localType);
      relatedDescriptions[localType] = related.descriptions[localType];
    }
  });
  updateDoc(fireBoxTypeRef, {
    related: { types: relatedTypes, descriptions: relatedDescriptions },
  });
}

async function checkIfPlayerBoxTypeDocExists(playerId, boxTypeName, onCheck) {
  const openDocRef = doc(db, `players/${playerId}/open/`, boxTypeName);
  const savedDocRef = doc(db, `players/${playerId}/saved/`, boxTypeName);
  const openDocSnap = await getDoc(openDocRef);
  const savedDocSnap = await getDoc(savedDocRef);
  if (!openDocSnap.exists()) {
    setDoc(openDocRef, { array: [] });
  }
  if (!savedDocSnap.exists()) {
    setDoc(savedDocRef, { array: [] }).then(() => {
      onCheck();
    });
  }
  if (openDocSnap.exists() && savedDocSnap.exists()) onCheck();
}

async function checkIfBoxHistoryDocumentExists(
  playerId,
  type,
  boxId,
  onChecked,
  payload
) {
  const docRef = doc(db, `players/${playerId}/history`, `${type}!${boxId}`);
  const historyDoc = await getDoc(docRef);
  console.log(
    "complete goal 6| checkIfBoxHistoryDocumentExists | payload - ",
    payload
  );

  if (historyDoc.exists()) {
    console.log("doc Exists");
    onChecked(historyDoc.data(), payload);
  } else {
    const obj = { id: boxId, array: [] };
    console.log("does not exist");
    setDoc(docRef, obj).then(() => {
      onChecked(obj, payload);
    });
  }
}

async function updateBoxHistory(playerId, boxId, type, historyArray) {
  const docRef = doc(db, `players/${playerId}/history`, `${type}!${boxId}`);
  updateDoc(docRef, { array: historyArray });
}

export {
  updateBoxHistory,
  checkIfBoxHistoryDocumentExists,
  checkIfPlayerBoxTypeDocExists,
  checkGeneralRelatedTypes,
  getBoxTypesInformation,
  incrementBoxTypeUsed,
  getBoxTypeDocuments,
  saveBoxType,
  findObjectsByEntries,
  addRatingToGeneralObject,
  addToDataRelatedArray,
  reduceGeneralArray,
  incrementGeneralArray,
  updatePlayerArray,
  resetAddedQuota,
  getObjectFromFirestore,
  updateTypeObject,
  getTypeObject,
  incrementPlayerField,
  handlePlayerRetrival,
  createPlayer,
  uploadImageToStorage,
  getGeneralLists,
  updatePlayerAttribute,
  collectionObj,
  getArrayListener,
};
